export default "__VITE_ASSET__BxqTuRbj__"